'use client';

import { Suspense, useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { INQ_ID_SESSION_STORAGE_KEY } from '@/constants/inq-id';
import { isValidInquiryLeadId } from '@/utils/is-valid-inquiry-lead-id';
import { getSessionStorageItem } from '@/utils/session-storage/safe-session-storage';

const InqIdFormBridgeInner = () => {
  const searchParams = useSearchParams();
  const [value, setValue] = useState('');

  useEffect(() => {
    const stored = getSessionStorageItem(INQ_ID_SESSION_STORAGE_KEY)?.trim();
    if (stored && isValidInquiryLeadId(stored)) {
      setValue(stored);
      return;
    }
    setValue('');
  }, [searchParams]);

  return <input type="hidden" name="inq_id" value={value} />;
};

/**
 * Exposes the stored lead `inq_id` to the availability form.
 * URL capture and stripping is handled by `InqIdUrlCapture` on the listing detail page.
 */
export const InqIdFormBridge = () => (
  <Suspense
    fallback={<input type="hidden" name="inq_id" value="" aria-hidden />}
  >
    <InqIdFormBridgeInner />
  </Suspense>
);
